'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withComponentMapping = exports.ComponentProvider = undefined;

var _ComponentProvider = require('./ComponentProvider');

var _ComponentProvider2 = _interopRequireDefault(_ComponentProvider);

var _withComponentMapping = require('./with-component-mapping');

var _withComponentMapping2 = _interopRequireDefault(_withComponentMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ComponentProvider = _ComponentProvider2.default;
exports.withComponentMapping = _withComponentMapping2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-provider/lib/cjs/index.js
 ** module id = 481
 ** module chunks = 1
 **/